import { LG_BREAKPOINT } from './constants';

export function isSmallScreen() {
  return typeof window !== 'undefined' ? window.innerWidth < LG_BREAKPOINT : false;
}
